"use client";

import { useState } from "react";
import { trackEvent } from "@/lib/analytics";
import s from "./climate.module.css";

const PUBLIC_VIEW_KEYS = new Set([
  "pathway",
  "period",
  "seaYear",
  "seaPathway",
  "heat",
  "temperature",
  "snowmaking",
  "skiRegion",
  "altitude",
  "elevation",
  "waveRegion",
  "coral",
  "sport",
  "story",
  "step",
  "target",
  "location",
  "metric",
  "historyView",
  "heatmap",
  "month",
  "compareSport",
  "compareA",
  "compareB",
  "compareC",
  "coastA",
  "coastB",
  "coastC",
  "compareAltitude",
  "snowMassif",
  "snowScenario",
  "snowAltitude",
  "seasonStation",
  "seasonPeriod",
  "seasonTiming",
]);

export function CopyViewLink({
  anchor,
  label = "Copy this comparison link",
}: {
  anchor: string;
  label?: string;
}) {
  const [message, setMessage] = useState("");
  const [fallback, setFallback] = useState("");
  async function copy() {
    const url = new URL("https://peakwave.co/climate");
    new URLSearchParams(window.location.search).forEach((value, key) => {
      if (PUBLIC_VIEW_KEYS.has(key) && /^[a-z0-9_.-]{1,45}$/i.test(value))
        url.searchParams.set(key, value);
    });
    url.hash = anchor;
    try {
      await navigator.clipboard.writeText(url.toString());
      setMessage("Link copied. Your selections will reopen with it.");
      setFallback("");
      trackEvent("climate_chart_action", {
        chart: anchor === "compare" ? "comparison" : "local-history",
        action: "copy-link",
      });
    } catch {
      setFallback(url.toString());
      setMessage("Select and copy the link below.");
    }
  }
  return (
    <div className={s.viewLink}>
      <button type="button" onClick={copy}>
        {label}
      </button>
      <span role="status">{message}</span>
      {fallback && (
        <input
          aria-label="Link to this climate view"
          readOnly
          value={fallback}
          onFocus={(event) => event.target.select()}
        />
      )}
    </div>
  );
}
